import type { ApiConfig } from '../../types'

export const convertHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'asc',
  range: 30 * 24 * 60 * 60 * 1000, // 30 days
  requestDelay: 500, // レートリミット対策 (SAPI / -1003 発生実績あり)
  requiresRange: true,
  type: 'convert-history',
} as const satisfies ApiConfig
